<div class="main-content">
  <div class="main-heading">
    <span translate>EDIT_USER</span>
  </div>
  <div class="card">
    <div class="card-body">
      <form [formGroup]="adminUserEditForm" class="form">
        <adminuser-form [adminUserForm]="adminUserEditForm"></adminuser-form>
        <div *ngIf="usernameWarning === 'deleted'" class="alert alert-info mb-2">
          <span translate>USERNAME_DELETED_INFO</span>
        </div>
        <div *ngIf="usernameWarning === 'inactive'" class="alert alert-warning mb-2">
          <span translate>USERNAME_INACTIVE_WARN</span>
        </div>
        <div class="action-btns-wrapper">
          <a
            class="btn btn-outline-secondary"
            role="button"
            [routerLink]="['../../list']"
          >
            <i class="pi pi-arrow-left"></i>
            <span translate>BACK_LIST</span>
          </a>
          <button
            class="btn btn-primary"
            type="submit"
            (click)="saveChanges()"
            [disabled]="!adminUserEditForm.valid"
          >
            <span translate>SAVE_CHANGES</span>
          </button>
          <button class="btn btn-danger" (click)="showResetPassword()">
            <span translate>RESET_PASSWORD</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<p-dialog
  header="{{ 'RESET_PASSWORD' | translate }}"
  (onHide)="clear()"
  [(visible)]="showPasswordResetDialog"
  [style]="{ width: '500px', height: '500px' }"
  [resizable]="false"
  [draggable]="false"
>
  <form [formGroup]="updatePasswordForm">
    <div formGroupName="passwordValidation">
      <app-password-validator
        [isReset]="isResetPasswordForm"
        (validChange)="onValidChange($event)"
        (passwordChange)="onPasswordChange($event)"
      >
      </app-password-validator>
    </div>

    <button
      class="btn btn-outline-primary"
      (click)="resetPassWord(false)"
      [disabled]="!updatePasswordForm.valid"
    >
      <span translate>SAVE</span>
    </button>
    <button
      class="btn btn-primary"
      (click)="resetPassWord(true)"
      [disabled]="!updatePasswordForm.valid"
    >
      <span translate>USERINFO_SMS</span>
    </button>
    <ul *ngIf="validationErrors.length > 0" style="color:red; padding-left: 15px; margin: 8px 0; list-style-type: disc;">
      <li *ngFor="let err of validationErrors">{{ err | translate }}</li>
    </ul>
  </form>
</p-dialog>

<p-dialog
  header="{{ 'RESET_PASSWORD' | translate }}"
  (onHide)="clear()"
  [(visible)]="passwordValidation"
  [style]="{ width: '500px', height: '500px' }"
  [resizable]="false"
  [draggable]="false"
>
  <span translate style="color: red">YOUR_PASSWORD_DONOT_MATCH</span>
</p-dialog>
